<div class="tab-selector feedTabs">
    <mat-tab-group (selectedIndexChange)="onTabChange($event)" [(selectedIndex)]="selectedIndex" color="accent"
                   disableRipple fitInkBarToContent>
        @for (option of options; track option) {
            <mat-tab [class.customColor]="option.color" [label]="option.label"
                     [style.color]="option.color"></mat-tab>
        }
    </mat-tab-group>
</div>
